'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { MANUFACTURER_TABS, MANUFACTURER_TABS_BLOCK_ID, MANUFACTURER_TABS_HEADING, type ManufacturerTab, type SubSection } from '../page-content';
import { RichLines } from './RichText';
import styles from '../page.module.css';
function ManufacturerPanel(t0) {
  const $ = _c(14);
  const {
    tab,
    isActive
  } = t0;
  const t1 = `mfr-panel-${tab.id}`;
  const t2 = `mfr-tab-${tab.id}`;
  const t3 = !isActive;
  const t4 = `${MANUFACTURER_TABS_BLOCK_ID}.${tab.id}`;
  const t5 = tab.headingOverride ?? tab.label;
  let t6;
  if ($[0] !== t5) {
    t6 = <h4 className={styles.tabH4} data-cms-field="label">{t5}</h4>;
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== tab.id) {
    t7 = tab.id === "scw" ? <hr /> : null;
    $[2] = tab.id;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== tab.subSections) {
    t8 = tab.subSections.map(_temp);
    $[4] = tab.subSections;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t6 || $[11] !== t7 || $[12] !== t8) {
    t9 = <div role="tabpanel" id={t1} aria-labelledby={t2} hidden={t3} className={styles.tabPanel} data-cms-block-id={t4}>{t6}{t7}{t8}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
}
function _temp(sub, idx) {
  return <div key={idx} className={styles.subSection}><h3 className={styles.tabH3} data-cms-field="subSection.heading">{sub.heading}</h3><RichLines lines={sub.body} className={styles.p} />{sub.trailingHr ? <hr /> : null}</div>;
}
export function ManufacturerTabs() {
  const $ = _c(12);
  const [activeId, setActiveId] = useState(MANUFACTURER_TABS[0]?.id ?? "scw");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className={styles.h2} data-cms-field="title">{MANUFACTURER_TABS_HEADING}</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== activeId) {
    t1 = MANUFACTURER_TABS.map(tab => {
      const isActive = tab.id === activeId;
      return <a key={tab.id} href="#" role="tab" id={`mfr-tab-${tab.id}`} aria-controls={`mfr-panel-${tab.id}`} aria-selected={isActive} tabIndex={isActive ? 0 : -1} data-content={tab.id} className={isActive ? `${styles.tabBtn} ${styles.tabBtnActive}` : styles.tabBtn} onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        setActiveId(tab.id);
      }}>{tab.label}</a>;
    });
    $[1] = activeId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div role="tablist" aria-label="RTSP URL formats by manufacturer" className={styles.tabsButtons}>{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== activeId) {
    t3 = MANUFACTURER_TABS.map(tab_0 => <ManufacturerPanel key={tab_0.id} tab={tab_0} isActive={tab_0.id === activeId} />);
    $[5] = activeId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className={styles.tabsContent}>{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <section data-cms-block-id={MANUFACTURER_TABS_BLOCK_ID} className={styles.section}>{t0}<div className={styles.tabsWrapper}>{t2}{t4}</div></section>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}